import BoletoRepositoryComponent from 'components/PlugbankComponents/Charge/BoletoRepository'
import { connect } from 'react-redux'
import { getCompany } from 'ducks/app'
import {
  closeBoletoDetail,
  downloadBoleto,
  initialBoletoLoader,
  openBoletoDetail,
  reSendEmail
} from 'ducks/charges'

const mapStateToProps = state => {
  return {
    boletoDetail: state.charges.boletoDetailsData,
    company: getCompany(state),
    detail: state.charges.detail
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    initialLoad: (params) => {
      dispatch(initialBoletoLoader(params))
    },
    onDownload: downloadBoleto,
    openBoletoDetail: (chargeId) => {
      dispatch(openBoletoDetail(chargeId))
    },
    closeBoletoDetail: () => {
      dispatch(closeBoletoDetail())
    },
    onResendMail: (chargeId) => {
      reSendEmail(chargeId)
    }
  }
}

const BoletoRepositoryLink = connect(
  mapStateToProps,
  mapDispatchToProps
)(BoletoRepositoryComponent)

export default BoletoRepositoryLink
